
export const areTargetingCookiesAllowed = () => {
  const otActiveGroups = window.OnetrustActiveGroups || '';
  return otActiveGroups.indexOf(',C0004,') > -1;
}